import React from 'react';
import PropTypes from 'prop-types';
import MoreResources from './MoreResources';
import TopicQuestions from './TopicQuestions';
import DailyVideos from './daily/DailyVideos';
import SourceResources from './SourceResources';
import { ResourceTypes, WL_RESOURCES } from '../utils/constants';

const MORE_RESOURCE_TYPES = [
  ResourceTypes.DISTANCE_LINK,
  ResourceTypes.PARTNER_LINK,
  ResourceTypes.EBOOK,
  ResourceTypes.URL,
  ResourceTypes.PROFESSIONAL_LEARNING,
];

const unwrapSubunitResources = (resources = [], apSourcesFlag) => {
  const groupsMap = resources.reduce((acc, curr) => {
    const group = curr.group ?? '';
    acc[group] = [...(acc[group] || []), curr];
    return acc;
  }, {});

  return Object.keys(groupsMap).map((group) => {
    resources = groupsMap[group];
    let videoResources = [];
    let moreResources = [];
    let topicQuestions = [];
    let sourceResources = [];

    resources.forEach((res) => {
      const { __typename } = res;
      if (__typename === ResourceTypes.PRACTICE_QUESTIONS) {
        topicQuestions = res.questions || [];
      }
      if (MORE_RESOURCE_TYPES.includes(__typename)) {
        moreResources.push(res);
      }

      if (
        __typename === ResourceTypes.SOURCE &&
        (apSourcesFlag || Object.values(WL_RESOURCES).includes(res.contentType))
      ) {
        sourceResources.push(res);
      }
      if (__typename === ResourceTypes.LTI) {
        sourceResources.push(res);
      }
      if (__typename === ResourceTypes.EMBEDDED_VIDEO) {
        videoResources.push(res);
      }
    });
    return {
      groupDisplayName: resources[0].displayName,
      group,
      videoResources,
      moreResources,
      topicQuestions,
      sourceResources,
    };
  });
};

const SubunitContent = ({
  userData,
  resources = [],
  unitNumber,
  subunitNumber,
  unitTitle,
  subunitTitle,
  widgetTagColumn,
  unitsLabel,
  metadata,
  useClassroomResourceAddress,
  subjectData,
  assignAllVideos,
  subunitLabel,
  unitDisplayName,
  apSourcesFlag,
}) => {
  const unwrapedResources = unwrapSubunitResources(resources, apSourcesFlag);

  const showResources = (items = []) => items && items.length > 0;

  return unwrapedResources.map(
    ({
      videoResources,
      moreResources,
      topicQuestions,
      sourceResources,
      groupDisplayName,
      group,
    }) => {
      // FY-21652 - we can display and assign only topic questions for which all topics were covered
      const assignableTopicQuestions = topicQuestions.filter(
        (item) => item.hasAllTopicsCovered === true,
      );

      return (
        <div className="px-1 flex flex-col w-full divide-y divide-solid divide-gray-400 border-b border-gray-300">
          {showResources(videoResources) && (
            <DailyVideos
              unitNumber={unitNumber}
              userData={userData}
              items={videoResources}
              subjectData={subjectData}
              assignAllVideos={assignAllVideos}
              subunitTitle={subunitTitle}
              subunitLabel={subunitLabel}
              unitTitle={unitDisplayName}
            />
          )}
          {showResources(assignableTopicQuestions) && (
            <TopicQuestions
              unitNumber={unitNumber}
              subunitNumber={subunitNumber}
              unitTitle={unitTitle}
              subunitTitle={subunitTitle}
              subunitLabel={subunitLabel}
              widgetTagColumn={widgetTagColumn}
              unitsLabel={unitsLabel}
              items={topicQuestions}
              metadata={metadata}
            />
          )}
          {showResources(sourceResources) && (
            <SourceResources
              unitNumber={unitNumber}
              items={sourceResources}
              useClassroomResourceAddress={useClassroomResourceAddress}
              masterSubjectId={subjectData.id}
            />
          )}
          {showResources(moreResources) && (
            <MoreResources
              title={group ? groupDisplayName : null}
              unitNumber={unitNumber}
              items={moreResources}
              useClassroomResourceAddress={useClassroomResourceAddress}
            />
          )}
        </div>
      );
    },
  );
};

SubunitContent.propTypes = {
  userData: PropTypes.object.isRequired,
  unitNumber: PropTypes.string.isRequired,
  subunitNumber: PropTypes.string,
  unitTitle: PropTypes.string.isRequired,
  subunitTitle: PropTypes.string.isRequired,
  widgetTagColumn: PropTypes.string,
  unitsLabel: PropTypes.string,
  metadata: PropTypes.string,
  useClassroomResourceAddress: PropTypes.bool,
  assignAllVideos: PropTypes.bool.isRequired,
  subunitLabel: PropTypes.string.isRequired,
  unitDisplayName: PropTypes.string.isRequired,
};

SubunitContent.defaultProps = {
  useClassroomResourceAddress: false,
  widgetTagColumn: '',
  unitsLabel: '',
  metadata: '',
  subunitNumber: '',
};
export default SubunitContent;
